<template>
    <div v-if="report.personalInformation != null && report.personalInformation.length > 0" class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-content">
                    <div class="table-responsive">
                        <table v-if="report.personalInformation.length > 0" class="table table-success table-hover table-striped mb-0">
                            <thead class="thead-primary">
                                <tr>
                                    <th style="width:200px"></th>
                                    <th style="width:200px">
                                        <img :src="reportStore.images.transunion" alt="image" width="75" height="75" class="d-block">
                                    </th>
                                    <th style="width:200px">
                                        <img :src="reportStore.images.experian" alt="image" width="75" height="75" class="d-block">
                                    </th>
                                    <th style="width:200px">
                                        <img :src="reportStore.images.equifax" alt="image" width="75" height="75" class="d-block">
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="table-striped" >
                                <tr scope="row">
                                    <td>
                                        {{ localizationStore.translate("report.personal.information.table.row.one") }}
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('TransUnion', 'report').name }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && getPersonalInformation('TransUnion', 'report').name != getPersonalInformation('TransUnion', 'previousReport').name">
                                            {{ getPersonalInformation('TransUnion', 'previousReport').name }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Experian', 'report').name }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && getPersonalInformation('Experian', 'report').name != getPersonalInformation('Experian', 'previousReport').name">
                                            {{ getPersonalInformation('Experian', 'previousReport').name }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Equifax', 'report').name }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && getPersonalInformation('Equifax', 'report').name != getPersonalInformation('Equifax', 'previousReport').name">
                                            {{ getPersonalInformation('Equifax', 'previousReport').name }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr scope="row">
                                    <td>
                                        {{ localizationStore.translate("report.personal.information.table.row.two") }}
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(getPersonalInformation('TransUnion', 'report').dob, reportStore.dateFormat) }}
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                getPersonalInformation('TransUnion', 'report').dob != getPersonalInformation('TransUnion', 'previousReport').dob
                                            "
                                        >
                                            {{ formatDate(getPersonalInformation('TransUnion', 'previousReport').dob, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(getPersonalInformation('Experian', 'report').dob, reportStore.dateFormat) }}
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                getPersonalInformation('Experian', 'report').dob != getPersonalInformation('Experian', 'previousReport').dob
                                            "
                                        >
                                            {{ formatDate(getPersonalInformation('Experian', 'previousReport').dob, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(getPersonalInformation('Equifax', 'report').dob, reportStore.dateFormat) }}
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                getPersonalInformation('Equifax', 'report').dob != getPersonalInformation('Equifax', 'previousReport').dob
                                            "
                                        >
                                            {{ formatDate(getPersonalInformation('Equifax', 'previousReport').dob, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {{ localizationStore.translate("report.personal.information.table.row.three") }}
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('TransUnion', 'report').aka_name }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('TransUnion', 'previousReport').aka_name.includes('-') && getPersonalInformation('TransUnion', 'report').aka_name != getPersonalInformation('TransUnion', 'previousReport').aka_name">
                                            {{ getPersonalInformation('TransUnion', 'previousReport').aka_name }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Experian', 'report').aka_name }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('Experian', 'previousReport').aka_name.includes('-') && getPersonalInformation('Experian', 'report').aka_name != getPersonalInformation('Experian', 'previousReport').aka_name">
                                            {{ getPersonalInformation('Experian', 'previousReport').aka_name }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Equifax', 'report').aka_name }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('Equifax', 'previousReport').aka_name.includes('-') && getPersonalInformation('Equifax', 'report').aka_name != getPersonalInformation('Equifax', 'previousReport').aka_name">
                                            {{ getPersonalInformation('Equifax', 'previousReport').aka_name }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr scope="row">
                                    <td>
                                        {{ localizationStore.translate("report.personal.information.table.row.four") }}
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('TransUnion', 'report').former }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('TransUnion', 'previousReport').former.includes('-') && getPersonalInformation('TransUnion', 'report').former != getPersonalInformation('TransUnion', 'previousReport').former">
                                            {{ getPersonalInformation('TransUnion', 'previousReport').former }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Experian', 'report').former }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('Experian', 'previousReport').former.includes('-') && getPersonalInformation('Experian', 'report').former != getPersonalInformation('Experian', 'previousReport').former">
                                            {{ getPersonalInformation('Experian', 'previousReport').former }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Equifax', 'report').former }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('Equifax', 'previousReport').former.includes('-') && getPersonalInformation('Equifax', 'report').former != getPersonalInformation('Equifax', 'previousReport').former">
                                            {{ getPersonalInformation('Equifax', 'previousReport').former }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {{ localizationStore.translate("report.personal.information.table.row.five") }}
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('TransUnion', 'report').current_addresses }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('TransUnion', 'previousReport').current_addresses.includes('-') && getPersonalInformation('TransUnion', 'report').current_addresses.trim() != getPersonalInformation('TransUnion', 'previousReport').current_addresses.trim()">
                                            {{ getPersonalInformation('TransUnion', 'previousReport').current_addresses }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Experian', 'report').current_addresses }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('Experian', 'previousReport').current_addresses.includes('-') && getPersonalInformation('Experian', 'report').current_addresses.trim() != getPersonalInformation('Experian', 'previousReport').current_addresses.trim()">
                                            {{ getPersonalInformation('Experian', 'previousReport').current_addresses }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Equifax', 'report').current_addresses }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('Equifax', 'previousReport').current_addresses.includes('-') && getPersonalInformation('Equifax', 'report').current_addresses.trim() != getPersonalInformation('Equifax', 'previousReport').current_addresses.trim()">
                                            {{ getPersonalInformation('Equifax', 'previousReport').current_addresses }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {{ localizationStore.translate("report.personal.information.table.row.six") }}
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('TransUnion', 'report').previous_addresses }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('TransUnion', 'previousReport').previous_addresses.includes('-') && getPersonalInformation('TransUnion', 'report').previous_addresses != getPersonalInformation('TransUnion', 'previousReport').previous_addresses">
                                            {{ getPersonalInformation('TransUnion', 'previousReport').previous_addresses }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Experian', 'report').previous_addresses }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('Experian', 'previousReport').previous_addresses.includes('-') && getPersonalInformation('Experian', 'report').previous_addresses != getPersonalInformation('Experian', 'previousReport').previous_addresses">
                                            {{ getPersonalInformation('Experian', 'previousReport').previous_addresses }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Equifax', 'report').previous_addresses }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('Equifax', 'previousReport').previous_addresses.includes('-') && getPersonalInformation('Equifax', 'report').previous_addresses != getPersonalInformation('Equifax', 'previousReport').previous_addresses">
                                            {{ getPersonalInformation('Equifax', 'previousReport').previous_addresses }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {{ localizationStore.translate("report.personal.information.table.row.seven") }}
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('TransUnion', 'report').employers }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('TransUnion', 'previousReport').employers.includes('-') && getPersonalInformation('TransUnion', 'report').employers != getPersonalInformation('TransUnion', 'previousReport').employers">
                                            {{ getPersonalInformation('TransUnion', 'previousReport').employers }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Experian', 'report').employers }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('Experian', 'previousReport').employers.includes('-') && getPersonalInformation('Experian', 'report').employers != getPersonalInformation('Experian', 'previousReport').employers">
                                            {{ getPersonalInformation('Experian', 'previousReport').employers }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ getPersonalInformation('Equifax', 'report').employers }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && !getPersonalInformation('Equifax', 'previousReport').employers.includes('-') && getPersonalInformation('Equifax', 'report').employers != getPersonalInformation('Equifax', 'previousReport').employers">
                                            {{ getPersonalInformation('Equifax', 'previousReport').employers }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="!reportStore.reports[email].haveReport">
        <div class="col-sm-12">
            <div class="card" :class="{ 'shadow': $route.params.client }" >
                <div class="card-body">
                    <div class="mx-auto">
                        <h3 class="text-center text-warning mb-1">Oops...Your Credit Report is Missing.</h3>
                        <h6 class=" text-center text-warning mb-2">In order view the Dispute Center, you must import your Credit Report.
                            <br> If you don't already have a credit report, you can get one by clicking the button below.
                        </h6>
                    </div>
                    <div style="text-align:center;">
                        <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                            class="btn btn-warning ">
                            <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p v-else class="text-center font-medium-3 text-bold-600 warning"> You don't have any Report Data.</p>
</template>

<script>
    import { reactive, computed } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { formatDate } from '../../utilities/_helpers'
    export default {
        mounted() {
        },
        props: {
            email: String
        },
        setup(props) {
            return {
                localizationStore: useLocalizationStore(),
                reportStore: useReportStore(),
                report: useReportStore().reports[props.email].report,
                previousReport: useReportStore().reports[props.email].previousReport,
                formatDate: formatDate
            }
        },
        methods: {
            getPersonalInformation(creditReportingAgency, reportType) {
                return this[reportType].personalInformation.find((reportPersonalInformation) => {
                    if (reportPersonalInformation.credit_reporting_agency.name == creditReportingAgency) {
                        return reportPersonalInformation;
                    }
                })
            }
        },
        computed: {
            
        },
    }
</script>
